module.exports = __webpack_public_path__ + "img/logo-light.78fbfd34.png";